import { invoicePaymentDate } from './invoiceKanbanDates';

/** Match the original attachment filename, including plural and mixed-case names. */
export function isInvoiceAttachment(name: string): boolean {
  return /factura|fatura|invoice/i.test(name);
}

export type InvoiceStatus = 'pending' | 'delayed' | 'complete' | 'canceled';
export function resolveInvoiceStatus(paymentDate: string, hasInvoiceAttachment: boolean, manualStatus?: string, today = new Date()): InvoiceStatus {
  if (manualStatus === 'canceled') return 'canceled';
  if (hasInvoiceAttachment) return 'complete';
  const date = invoicePaymentDate(paymentDate);
  const currentDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return date && date < currentDay ? 'delayed' : 'pending';
}
